import Vue from 'vue'
import $ from 'jquery'

function scroll (el) {
  el.scrollIntoView({ behavior: 'smooth' })
  el.classList.add('anchor-selected')
  el.classList.remove('anchor-not-selected')
  setTimeout(() => {
    el.classList.add('anchor-not-selected')
    el.classList.remove('anchor-selected')
    el.scrollIntoView()
  }, 500)
}

Vue.directive('id', {
  bind (el, binding, vnode) {
    let $el = $(el)
    el.classList.add('anchor')
    el.classList.add('anchor-not-selected')
    $el.data('v-id-listener', () => {
      if (binding.value && '#' + binding.value === vnode.context.$route.hash) {
        scroll(el)
      }
    })
    if (binding.value) el.id = binding.value
    $el.data('v-id-cleaner',
      vnode.context.$watch('$route.hash', (hash, old) => {
        if (hash !== old && binding.value && '#' + binding.value === hash) {
          scroll(el)
        }
      })
    )
  },
  inserted: function (el, binding, vnode) {
    if (binding.value) el.id = binding.value
    if (binding.value && '#' + binding.value === vnode.context.$route.hash) {
      scroll(el)
    }
  },
  update: function (el, binding, vnode) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) el.id = binding.value
      else el.removeAttribute('id')
      if (binding.value && '#' + binding.value === vnode.context.$route.hash) {
        scroll(el)
      }
    }
  },
  unbind (el) {
    $(el).data('v-id-cleaner')()
  },
})

Vue.prototype.$anchorsLoaded = function () {
  let anchors = this.$el.getElementsByClassName('anchor')
  for (let i = 0; i < anchors.length; i++) {
    let listener = $(anchors[i]).data('v-id-listener')
    if (listener) listener()
  }
}
